import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/pacotes/base',
    name: 'Pacote Base',
    component: () => import(/* webpackChunkName: "packages" */ '../views/Base.vue')
  },
  {
    path: '/pacotes/plus',
    name: 'Pacote Plus',
    component: () => import(/* webpackChunkName: "packages" */ '../views/Plus.vue')
  },
  {
    path: '/pacotes/premium',
    name: 'Pacote Premium',
    component: () => import(/* webpackChunkName: "packages" */ '../views/Premium.vue')
  },
  {
    path: '/experiencias',
    name: 'Experiências',
    component: () => import(/* webpackChunkName: "experiences" */ '../views/Experiences.vue')
  },
  {
    path: '/fado',
    name: 'Noite de Fado',
    component: () => import(/* webpackChunkName: "experiences" */ '../views/Fado.vue')
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "errors" */ '../views/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
